<template>
  <div>
    <auth-container></auth-container>
    <t-dialog></t-dialog>
    <t-side-cart></t-side-cart>
    <div class="HeaderDes">
      <THeaderDesktop />
    </div>
  </div>
</template>

<script>

import {GET_WATCHLIST_LIST } from "../../../store/actions";
import { defineAsyncComponent } from 'vue'
import TDialog from "../../../../common/components/dialogs/TDialog.vue";

const AuthContainer = defineAsyncComponent(() =>
  import('../../../../domains/authentication/components/AuthContainer.vue')
)
const THeaderDesktop = defineAsyncComponent(() =>
  import('./THeaderDesktop')
)
const TSideCart = defineAsyncComponent(() =>
  import('../../../../domains/checkout/components/TSideCart.vue')
)

export default {
  components: {
    THeaderDesktop,
    TSideCart,
    AuthContainer,
    TDialog
  },
  methods: {},
  created() {
    if (
      this.$store.getters.customer != undefined &&
      this.$store.getters.customer.id != undefined
    )
      this.$store.dispatch(GET_WATCHLIST_LIST);

    if (
      localStorage.getItem("token") != undefined &&
      localStorage.getItem("token").length > 1
    ) {
    }
  },
};
</script>

<style lang="scss">
.HeaderDes {
  display: block;
}
.HeaderMob {
  display: none;
}


</style>
